import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdJiraAutomationRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-jira-automation',
	path: '/servicedesk/admin/:projectKey/automation',
};
